import { Actions } from 'vuex-smart-module';
import { ResponseStatuses } from '@/enums';
import ContactsState from './state';
import ContactsMutations from './mutations';
import ContactsGetters from './getters';
import { ContactsService } from '../services';

const contactsService = new ContactsService();

export default class ContactsActions extends Actions<
  ContactsState,
  ContactsGetters,
  ContactsMutations,
  // eslint-disable-next-line no-use-before-define
  ContactsActions
> {
  async get_contacts() {
    try {
      const { data } = await contactsService.get_contacts();

      this.mutations.SET_CARDS(data.items);
      this.mutations.SET_CARD_ITEMS(data.widgets);
    } catch (error) {
      console.log(error);
    }
  }

  async sent_appeal() {
    const form_data = this.state.appeal_payload;

    try {
      const { code } = await contactsService.sent_appeal(form_data);

      if (code === ResponseStatuses.Success.OK) {
        return true;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  }
}
